module.exports = __webpack_public_path__ + "img/img_charge_phone_img1.b852c517.png";